<?php

$userdata = \ISOPHP\core::$registry->getValue('user_logged')['user'];

\Core\View::$template = function () use ($userdata) {

    $html = ''; 
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);    
    \ISOPHP\js_core::$console->log('user_data: ', $userdata);    
    $rqd = $pv['request_data']['data'];

    $html = '
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-12"  id="job_' . $rqd['id'] . '">
                            <div class="job_details_wrap">

                                <div class="row">
                                    <div class="col-12 col-sm-10 order-sm-1 order-2">
                                        <div class="job_head">

                                            <div class="row clearfix">
                                                <div class="col-sm-12">
                                                    <p class="job_id_title">Job ID: <span class="job_id">' . $rqd['id'] . '</span></p>
                                                </div>
                                            </div>
                                            <div id="job_' . $rqd['id'] . '" class="row jobs-details">
                                                <div class="col-sm-12">
                                                    <h6 class="job_title">' . $rqd['title'] . '</h6>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="label_wrap">
                                                        <p class="job_lebels job_job_type"><i class="fa fa-graduation-cap"></i>' . $rqd['job_type'] . '</p>
                                                        <p class="job_lebels job_job_level"><i class="fa fa-briefcase  "></i>' . $rqd['job_level'] . '</p>
                                                        <p class="job_lebels job_location"><i class="fa fa-map-marker"></i>' . $rqd['job_location'] . '</p>';
                        if ($userdata['user_type'] == 2) {
                            $html = $html .            '<p class="job_lebels job_applicant"><i class="fa fa-user"></i>' . $rqd['applied_count'] . '</p>';
                        }
                        $html = $html .            '</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>';
    if ($userdata['user_type'] == 2) {
        $html = $html .            '<div class="col-12 col-sm-2 order-sm-2 order-1">
                                        <div class="job_employer">
                                            <button class="btn btn-primary go-employer-detail"  id="employer_' . $rqd['user_id'] . '">Employer Profile</button>                                      
                                            <button class="btn btn-primary invite_applicant"  data-job_id="' . $rqd['id'] . '">Invite</button>
                                        </div>
                                    </div>';
    }
    $html = $html . '
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 col-12">
                                        <p class="job_description text-justify">' . $rqd['description'] . '</p>
                                    </div>
                                </div>';                                
    $html = $html . '
                                <div class="row">
                                    <div class="col-sm-12 col-12">
                                        <label>Contact Person: </label><p class="contact_person text-justify">' . $rqd['contact_person'] . '</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-12">
                                    <label>Created Date: </label><p class="created_at text-justify">' . \ISOPHP\core::$php->date("F j, Y, g:i a", \ISOPHP\core::$php->strtotime($rqd['created_at'])) . '</p>
                                    </div>
                                </div>';
                                
        if(!empty($rqd['applied'])){
            $html = $html . '
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="label_wrap">';
            
            foreach ($rqd['applied'] as $applicant) {
                $now = \ISOPHP\core::$php->time();
                $iterview_at = \ISOPHP\core::$php->strtotime($applicant['interview_at']);
                if ($userdata['user_type'] == 2) {
                    $html = $html . '
                    <p class="btn btn-link review-application" id="review_application_'. $applicant['id'] .'">
                    ' . $applicant['appliedinfo']['full_name'] ;  
                                        
                    if($iterview_at > $now) {
                        $html = $html . ' <span class="interview_time"> Interview @ ' . \ISOPHP\core::$php->date("F j, Y, g:i a", $iterview_at) . '</span>';
                    }
                    $html = $html . '
                    </p>';               
                }
                if ( ($userdata['user_type'] == 1) && ($applicant['user_id'] == $userdata['id']) ) {
                    if(isset($applicant['interview_at'])){
                        $html = $html . '
                        <p> Dear, You have beed invited for interview. <br>';
                        if($iterview_at >= $now){
                            $html = $html . ' <span class="interview_time">Your Interview @ ' . \ISOPHP\core::$php->date("F j, Y, g:i a", $iterview_at) . '</span>';
                        }else{
                            $html = $html . 'Sorry! Your interview schedule expired.';
                        }
                        $html = $html . '
                        </p>';
                    }                    
                }
            }
            $html = $html . '                                    
                                </div>
                            </div>
                        </div>  ';
        }

    $html = $html . '
                            </div>
                        </div>
                    </div>
                </div>';

    return $html;

};



// WEBPACK FOOTER //
// app/JobList/View/JobDetails.php